import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import EmployeeImportConfiguration from "../model/EmployeeImportConfiguration";

const EmployeeImportConfigurationApiService = async (
  request: number
): Promise<EmployeeImportConfiguration[]> => {
  const url = `/employerdataimportconfiguration?employer=${request}`;
  const { data } = await axios.get(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useEmployerImportConfigurationApiService = (request: number ) =>
  useQuery<Promise<EmployeeImportConfiguration[]>, AxiosError, EmployeeImportConfiguration[]>(
    ["EmployeeListApiService", request], () =>
      EmployeeImportConfigurationApiService(request), { keepPreviousData : true }
  );
export default useEmployerImportConfigurationApiService;
